<template>
  <Modal :open="openModal" @close="closeModal">
    <div>
      <h1 class="font-bold text-lg py-4">Utilisateur en charge de la configuration</h1>
    </div>
    <form>
      <div class="space-y-4">
        <FormField
          id="firstName"
          label="First name"
          name="first_name"
          placeholder="First Name"
          v-model="profile.firstName"
        />
        <FormField
          id="lastName"
          label="Last name"
          name="last_name"
          placeholder="Last Name"
          v-model="profile.lastName"
        />
        <FormField id="email" label="Email" name="email" placeholder="john@doe.com" v-model="profile.email" />
        <Selector id="role" label="Role" name="role" v-model="profile.role" :options="roles" />
        <FormField id="phone" label="Numéro de téléphone" name="phone" v-model="profile.phone" />
      </div>
      <div class="mt-6 flex items-center justify-end gap-x-6">
        <button type="button" class="text-sm font-semibold leading-6 text-gray-900" @click="closeModal">Annuler</button>
        <div
          type="submit"
          class="cursor-pointer rounded-md px-3 py-2 text-sm font-semibold text-button-font-primary bg-primary uppercase shadow-xs"
          @click="configueStore"
        >
          Créer
        </div>
      </div>
    </form>
  </Modal>
</template>

<script>
import { FormField } from "@estaly/ui";
import { Modal } from "@estaly/ui";
import { Selector } from "@estaly/ui";
import { mapActions } from "vuex";

export default {
  components: {
    Modal,
    Selector,
    FormField,
  },
  props: ["openModal", "organizationId"],
  data() {
    return {
      profile: {
        firstName: "",
        lastName: "",
        email: "",
        role: "",
        phone: "",
      },
      roles: [
        { value: "organization_admin", label: "Admin réseau" },
        { value: "store_admin", label: "Admin magasin(s)" },
        { value: "manager", label: "Manager" },
      ],
    };
  },
  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("stores", ["configureStore"]),
    closeModal() {
      this.$emit("close");
    },
    async configueStore() {
      const storeParams = {
        store: {
          organizationId: this.organizationId,
          source: "offline",
          status: "setup",
          setupStatus: "information_to_be_completed",
          profile: this.profile,
        },
      };
      const response = await this.configureStore(storeParams);
      if (!response?.success) return;

      this.notify({
        category: "simple",
        type: "success",
        title: "Le lien d'activation a été envoyé.",
      });

      window.open(`/stores/${response.data.id}`, "_blank");

      this.$emit("updateOrganization");
      this.closeModal();
    },
  },
};
</script>
